import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import Footer from '@/components/Footer';
import ConnectionStatusBanner from '@/components/ConnectionStatusBanner';
import { CheckademicLogo } from '@/components/CheckademicLogo';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ThemeToggle } from '@/components/ThemeToggle';

const SuperAdminLayout = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <ConnectionStatusBanner />
      {/* Header - hardcoded brand colors to maintain consistent branding in dark mode */}
      <header
        style={{
          backgroundColor: '#00233c',
          color: 'white',
          padding: '1rem 2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <CheckademicLogo height="40px" primaryColor="white" accentColor="#f38d4b" textColor="white" />
          {!isMobile && (
            <span style={{ margin: '0 0 0 1em', fontSize: '1.25rem', fontWeight: 500 }}>Super Admin Portal</span>
          )}
        </div>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <ThemeToggle
            compact
            style={{
              color: 'rgba(255, 255, 255, 0.8)',
              borderColor: 'rgba(255, 255, 255, 0.3)',
            }}
          />
          <span
            onClick={() => navigate('/profile')}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                navigate('/profile');
              }
            }}
            title="View profile"
            style={{
              cursor: 'pointer',
              transition: 'text-decoration 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.textDecoration = 'none';
            }}
          >
            {user?.email}
          </span>
          <button onClick={handleLogout} className="btn btn-secondary">
            Logout
          </button>
        </div>
      </header>

      {/* Navigation */}
      <nav
        style={{
          backgroundColor: 'var(--background-secondary)',
          padding: '1rem 2rem',
          borderBottom: '1px solid var(--border-color)',
        }}
      >
        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
          {/* Core */}
          <Link to="/" style={{ color: 'var(--text-primary)' }}>
            Dashboard
          </Link>
          <Link to="/tenants" style={{ color: 'var(--text-primary)' }}>
            Tenants
          </Link>
          <Link to="/users/create" style={{ color: 'var(--text-primary)' }}>
            Create User
          </Link>

          <span style={{ borderLeft: '1px solid var(--border-color)', height: '1.25rem' }} />

          {/* Support */}
          <Link to="/support-tickets" style={{ color: 'var(--text-primary)' }}>
            Support Tickets
          </Link>
          <Link to="/announcements" style={{ color: 'var(--text-primary)' }}>
            Announcements
          </Link>

          <span style={{ borderLeft: '1px solid var(--border-color)', height: '1.25rem' }} />

          {/* Email */}
          <Link to="/notification-testing" style={{ color: 'var(--text-primary)' }}>
            Notifications
          </Link>
          <Link to="/notification-logs" style={{ color: 'var(--text-primary)' }}>
            Notification Logs
          </Link>
          <Link to="/email-suppression" style={{ color: 'var(--text-primary)' }}>
            Suppression List
          </Link>
          <Link to="/usage" style={{ color: 'var(--text-primary)' }}>
            Usage
          </Link>

          <span style={{ borderLeft: '1px solid var(--border-color)', height: '1.25rem' }} />

          {/* System */}
          <Link to="/logs" style={{ color: 'var(--text-primary)' }}>
            Logs
          </Link>
        </div>
      </nav>

      {/* Main Content */}
      <main style={{ flex: 1, padding: '0.5rem 2rem' }}>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default SuperAdminLayout;
